import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { ApiService } from 'src/app/core/api/api.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LaboratorioService {

  constructor(private api: ApiService) {}

  // `token` es legacy y se ignora (el token va en el header Bearer).

  /* ---------------------------- Laboratorios ---------------------------- */

  listarLaboratorios(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/laboratories/list', {});
  }

  crearLaboratorio(_token: string, nombre: string): Observable<{ result: any }> {
    return this.api.post('/laboratory/laboratories/create', { nombre });
  }

  editarLaboratorio(_token: string, idLaboratorio: number, nombre: string): Observable<{ result: any }> {
    return this.api.post('/laboratory/laboratories/update', { idLaboratorio, nombre });
  }

  actualizarEstadoLaboratorio(_token: string, idLaboratorio: number, estado: number): Observable<{ result: any }> {
    return this.api.post('/laboratory/laboratories/status', { idLaboratorio, estado });
  }

  /* ------------------------------- Ofertas ------------------------------ */

  listarOfertas(_token: string, idLaboratorio: number): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/offers/list', { idLaboratorio });
  }

  crearOferta(_token: string, payload: { idLaboratorio: number; codigo: string; nombre: string; valor: number }): Observable<{ result: any }> {
    return this.api.post('/laboratory/offers/create', { ...payload });
  }

  editarOferta(_token: string, idExamen: number, payload: { codigo: string; nombre: string; valor: number }): Observable<{ result: any }> {
    return this.api.post('/laboratory/offers/update', { idExamen, ...payload });
  }

  eliminarOferta(_token: string, idExamen: number): Observable<{ result: any }> {
    return this.api.post('/laboratory/offers/delete', { idExamen });
  }

  /* ------------------------- Información de pruebas ---------------------- */

  listarInformacionPruebas(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/test-info/list', {});
  }

  crearInformacionPrueba(_token: string, payload: any): Observable<{ result: any }> {
    return this.api.post('/laboratory/test-info/create', { ...payload });
  }

  editarInformacionPrueba(_token: string, idPrueba: number, payload: any): Observable<{ result: any }> {
    return this.api.post('/laboratory/test-info/update', { idPrueba, ...payload });
  }

  eliminarInformacionPrueba(_token: string, idPrueba: number): Observable<{ result: any }> {
    return this.api.post('/laboratory/test-info/delete', { idPrueba });
  }

  /* ------------------------------ Resultados ---------------------------- */

  listarResultadosLab(_token: string, params: {
    sucursal: string; estado: string;
    fechaInicio: string; fechaFin: string;
    start: number; length: number; search: string;
  }): Observable<{ data: any[]; recordsTotal: number; recordsFiltered: number }> {
    return this.api.post('/laboratory/results/list', {
      sucursal: params.sucursal,
      estado: params.estado,
      fechaInicio: params.fechaInicio,
      fechaFin: params.fechaFin,
      start: params.start,
      length: params.length,
      search: params.search
    });
  }

  pendientesLabSucursal(_token: string, sucursal: string): Observable<{ total: number }> {
    return this.api.post('/laboratory/results/pending-count', { sucursal });
  }

  agregarComentarioLab(_token: string, numOrden: string, comentario: string): Observable<{ result: any }> {
    return this.api.post('/laboratory/results/comment', { numOrden, comentario });
  }

  generarOrdenOrion(_token: string, codOrden: number): Observable<{ result: any }> {
    return this.api.post('/laboratory/results/generate-orion', { codOrden });
  }

  /* ------------------------- Estados de muestras ----------------------- */

  listarEstadosMuestras(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/sample-status/list', {});
  }

  listarPendientesTomaMuestras(_token?: string): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/sample-status/pending-samples', {});
  }

  detalleOrdenToma(_token: string, numeroOrden: string): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/sample-status/order-detail', { numeroOrden });
  }

  productoLaboratorioToma(_token: string, codigo: string): Observable<{ rows: any[] }> {
    return this.api.post('/laboratory/sample-status/product', { codigo });
  }

  buscarTomaPorCodigoOrden(_token: string, codigoOrden: string | number): Observable<{ row: any }> {
    return this.api.post('/laboratory/sample-status/scan', { codigoOrden });
  }

  actualizarEstadoMuestra(_token: string, id: number, estado: string): Observable<{ row: any }> {
    return this.api.post('/laboratory/sample-status/update', { id, estado });
  }

  conectarEstadosMuestrasSocket(): Socket {
    const token = localStorage.getItem('token') || '';
    return io(`${environment.apiBaseUrl}/sample-status`, {
      auth: { token },
      transports: ['websocket'],
    });
  }
}
